/* eslint-disable valid-jsdoc */
// used as a fallback if ff is not available
import { getRootDeputyFrame } from '@webapp-next/global-libs/deputy-embed';
const mock = {
  check<T = boolean>(): T {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return false;
  },
  checkPromise<T = boolean>(): Promise<T> {
    return Promise.reject();
  },
};

function logFF(featureFlagsObj: FeatureFlags, key: string): void {
  const root = getRootDeputyFrame();
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  root.DP?.ffLogs?.tmp_logFF(featureFlagsObj, key);
}

function client<T = boolean>(): FeatureFlags<T> {
  if (window.__APP__?.FF) {
    return window.__APP__?.FF as FeatureFlags<T>;
  }

  // TODO: this is returning the wrong value
  if (getRootDeputyFrame().$dt?.featureFlags) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return getRootDeputyFrame().$dt?.featureFlags;
  }

  // TODO: this is returning the wrong value
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return mock;
}

export type FeatureFlagValue<T = boolean> = Record<string, T>;
export type FeatureFlags<T = boolean> = Record<string, FeatureFlagValue>;

/**
 * @param: 'params' parameter is added to serve another integration (headless flatfile)
 * it is free to use if not implemented in the code, but please do not remove it.
 */
export function check<T = boolean>(
  string = '',
  params?: Record<string, any>
): T {
  const list = client<T>() || ({} as FeatureFlags<T>);

  logFF(list, string);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return list[string] || false;
}

export function checkPromise<T = boolean>(
  string: string,
  params?: Record<string, any>
): Promise<T> {
  const list = client() || {};
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return Promise.resolve().then(() => list[string] || false);
}

export default check;
